module.exports = __webpack_public_path__ + "img/76065.817b407e.svg";